import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { Title } from "../../../../themes/Default/components/Title";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../../../themes/Default/components/List";
import { Header as ListHeader } from "../../../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../../../themes/Default/components/List/components/Body";
import { TableHead } from "../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { useTranslation } from "react-i18next";
import { Slide, toast, ToastContainer } from "react-toastify";
import { Checkbox } from "../../../../themes/Default/components/Form/components/Checkbox";
import { Toaster } from "../../../../themes/Default/components/Toaster";
import { roles } from "../../../../services/utils/Roles";
import { useUserToken } from "../../../../hooks/core/UserToken";

const Contracts = () => {
    const { t } = useTranslation("common");
    const { studentId } = useParams();
    const navigate = useNavigate();
    const [contracts, setContracts] = useState();
    const [student, setStudent] = useState();
    const { useContractsListMutation, useArchiveContractMutation, useDeleteContractMutation } = studentsManagement;
    const [contractsList, { isLoading }] = useContractsListMutation();
    const [archiveContract] = useArchiveContractMutation();
    const [deleteContract] = useDeleteContractMutation();
    const { useViewStudentsMutation } = studentsManagement;
    const [viewStudent] = useViewStudentsMutation();
    const [paymentStartMonth, setPaymentStartMonth] = useState([]);
    const [selectedContracts, setSelectedContracts] = useState([]);
    const [{ getDecoded }] = useUserToken(); 
    const decodedToken = getDecoded();   

    const tabs = [
        { title: t("details"), onClick: () => gotoDetailsTab(studentId) },
        // { title: t("students.tests"), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), isActive: true },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t("groups.title"), onClick: () => gotoGroupsTab(studentId) },
        { title: t("students.certificates"), onClick: () => gotoCertificatesTab(studentId) },
        { title: t("documents"), onClick: () => gotoDocumentsTab(studentId) },
        { title: t("notes"), onClick: () => gotoNotesTab(studentId) },
    ];

    const gotoTestsTab = (studentId) => {
        navigate("/students/" + studentId + "/tests");
    };

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const gotoCertificatesTab = (studentId) => {
        navigate("/students/" + studentId + "/certificates");
    };

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate("/students/" + studentId + "/notes");
    };

    const gotoDocumentsTab = (studentId) => {
        navigate("/students/" + studentId + "/documents");
    };

    const gotoGroupsTab = (studentId) => {
        navigate("/students/" + studentId + "/groups");
    };

    const gotoNew = () => {
        navigate(`/students/${studentId}/contracts/add`);
    };

    const gotoView = (contractsId) => {
        navigate(`/students/${studentId}/contracts/${contractsId}/view`);
    };

    const gotoEdit = (contractsId) => {
        navigate(`/students/${studentId}/contracts/${contractsId}/edit`);
    };

    const formatDateToDMY = (value) => {

        const parts = value.split("-");

        const year = parts[0];
        const month = parseInt(parts[1], 10);
        const day = parseInt(parts[2], 10);

        return `${day < 10 ? `0${day}` : day}.${month < 10 ? `0${month}` : month}.${year}`;
    };

    const paymentStartMonths = () => {
        const options = [
            { id: 1, name: "Januar" },
            { id: 2, name: "Februar" },
            { id: 3, name: "Mart" },
            { id: 4, name: "April" },
            { id: 5, name: "Maj" },
            { id: 6, name: "Jun" },
            { id: 7, name: "Jul" },
            { id: 8, name: "Avgust" },
            { id: 9, name: "Septembar" },
            { id: 10, name: "Oktobar" },
            { id: 11, name: "Novembar" },
            { id: 12, name: "Decembar" }
        ];
    
        return options;
    };

    const onSelectionChange = (id) => {
        setSelectedContracts((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((recordId) => recordId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const onArchiveContract = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedContracts?.length; i++) {
                            const contractId = selectedContracts[i];
                            archiveContract({studentId, contractId}).then((result) => {
                                if (result?.error) {
                                    toast.error(result.error.data.error.responseMessage);
                                } else {
                                    loadContracts();
                                    toast.info(result?.data?.info?.responseMessage);
                                    onSelectionChange(contractId);
                                }
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const onDelete = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedContracts?.length; i++) {
                            const contractId = selectedContracts[i];
                            deleteContract({studentId, contractId}).then((result) => {
                                if (result?.error) {
                                    toast.error(result.error.data.error.responseMessage);
                                } else {
                                    loadContracts();
                                    toast.info(result?.data?.info?.responseMessage);
                                    onSelectionChange(contractId);
                                }
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const loadContracts = () => {
        contractsList({ studentId }).then((result) => {
            setContracts(result?.data?.records);
        });
    };

    useEffect(() => {
        loadContracts();
        setPaymentStartMonth(paymentStartMonths);
    }, [studentId, contractsList]);

    useEffect(() => {
        viewStudent(studentId).then((result) => {
            setStudent(result?.data);
        });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/students" />
                <Button title={t("students.addContract")} icon="fa-regular fa-plus" onClick={gotoNew}></Button>
                <Button title={t("students.archiveContract")} icon="fa-regular fa-box-archive" onClick={onArchiveContract} isDisabled={selectedContracts.length === 0}></Button>
                {(decodedToken?.roles.includes(roles.SUPER_ADMIN)) && (
                    <>
                        <Button title={t("delete")} icon="fa-regular fa-trash-can" isDisabled={selectedContracts.length === 0} onClick={onDelete} />
                    </>
                )}
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>
                    {student?.firstName} {student?.lastName}
                </Title>
                <Breadcrumps>
                    <Link title={t("students.title")} icon="fa-user-graduate" />
                    <Link title={t("students.contract")} />
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                {!isLoading && (
                    <>
                        <List>
                            <ListHeader>
                            </ListHeader>
                            <ListBody>
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("status")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.contractSigned")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.canBePhotographed")}</span>
                                        </TableHeadCell>
                                        {/* <TableHeadCell>
                                            <span>{t("students.canGoHomeAlone")}</span>
                                        </TableHeadCell> */}
                                        <TableHeadCell>
                                            <span>{t("calendarHolidays.date")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.contractLegalEntity")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("program.language")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.contractTotalAmount")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.contractInstallmentDates")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("students.contractPaymentStartMonth")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {contracts?.length > 0 &&
                                        contracts?.map((contract, index) => {
                                            return (
                                                <TableRow key={contract.id}>
                                                    <TableDataCell>
                                                        <Button icon="fa-regular fa-eye" onClick={() => gotoView(contract.id)}></Button>
                                                        {/* <Button icon="fa-regular fa-pen" onClick={() => gotoEdit(contract.id)}></Button> */}
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <Checkbox name="isBlockClass" value={contract.id} onChange={() => onSelectionChange(contract.id)} />
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: contract.isArchived ? '#ff0000' : '#27ae60' }}>
                                                            {contract.isArchived ? t("students.archived") : t("students.active")}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: contract.signed ? '#27ae60' : '#ff0000' }}>
                                                            {contract.signed ? t("groups.hasStartedYes") : t("groups.hasStartedNo")}
                                                        </span>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <span style={{ color: contract.canBePhotographed ? '#27ae60' : '#ff0000' }}>
                                                            {contract.canBePhotographed ? t("groups.hasStartedYes") : t("groups.hasStartedNo")}
                                                        </span>
                                                    </TableDataCell>
                                                    {/* <TableDataCell>
                                                        <span style={{ color: contract.canGoHomeAlone ? '#27ae60' : '#ff0000' }}>
                                                        {contract.canGoHomeAlone === null
                                                            ? ''
                                                            : contract.canGoHomeAlone
                                                                ? t("groups.hasStartedYes")
                                                                : t("groups.hasStartedNo")}
                                                        </span>
                                                    </TableDataCell> */}
                                                    <TableDataCell>{formatDateToDMY(contract.date)}</TableDataCell>
                                                    <TableDataCell>{contract.legalEntityName}</TableDataCell>
                                                    <TableDataCell>{contract.languageName}</TableDataCell>
                                                    <TableDataCell>{contract.totalAmount + "RSD"}</TableDataCell>
                                                    <TableDataCell>{contract.installmentDates}</TableDataCell>
                                                    <TableDataCell>{paymentStartMonth.find(m => m.id === contract.paymentStartMonth)?.name}</TableDataCell>
                                                    <TableDataCell></TableDataCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </ListBody>
                        </List>
                    </>
                )}
            </Main>
        </DefaultLayout>
    );
};

export default Contracts;
